import React from 'react';
import OrderTracking from '../components/OrderTracking';

const OrderTrackingPage = () => {
  return <OrderTracking />;
};

export default OrderTrackingPage;

